export default "__VITE_ASSET__DmziUnWs__"